import React, { useState } from 'react';
import { AlarmClock } from 'lucide-react';
import { toast } from 'sonner';
import api from '@/lib/api';
import { errMsg } from './recoveryUi';

export default function ReminderTimes({ planId, plan, times, adjusted, onSaved }) {
  const [edit, setEdit] = useState(false);
  const [draft, setDraft] = useState(times);
  const meds = plan.medicines.filter((m) => !m.sos);
  if (!meds.length) return null;
  const save = async () => {
    try { await api.put(`/patient/recovery/${planId}/reminder-times`, { times: draft }); toast.success('Reminder times saved'); setEdit(false); onSaved(); }
    catch (e) { toast.error(errMsg(e, 'Could not save times')); }
  };
  return (
    <section className="rounded-2xl bg-white border border-slate-200 p-4 shadow-sm" data-testid="recovery-reminder-times">
      <div className="flex items-center justify-between">
        <h2 className="text-[15px] font-extrabold text-slate-900 flex items-center gap-2"><AlarmClock size={17} className="text-teal-700" /> Reminder times</h2>
        {!adjusted && !edit && <button type="button" onClick={() => setEdit(true)} className="text-[12px] font-bold text-teal-700" data-testid="recovery-times-adjust">Adjust once</button>}
      </div>
      <ul className="mt-2 space-y-2">
        {meds.map((m) => (
          <li key={m.key} className="flex items-center gap-2 text-[13.5px]">
            <span className="flex-1 font-semibold text-slate-800">{m.name}</span>
            {(edit ? draft[m.key] : times[m.key] || []).map((t, i) => edit ? (
              <input key={i} type="time" value={t} className="border border-slate-300 rounded-md px-1.5 py-1 text-[13px]"
                     onChange={(e) => setDraft({ ...draft, [m.key]: draft[m.key].map((x, j) => (j === i ? e.target.value : x)) })}
                     data-testid={`recovery-time-${m.key}-${i}`} />
            ) : <span key={i} className="px-2 py-0.5 rounded-md bg-slate-100 font-mono text-[12px]">{t}</span>)}
          </li>
        ))}
      </ul>
      {edit && (
        <button type="button" onClick={save} className="mt-3 w-full py-2.5 rounded-xl bg-slate-900 text-white text-[13px] font-bold" data-testid="recovery-times-save">
          Save — times can be changed only once
        </button>
      )}
    </section>
  );
}
